export { SitePageLayout, PageBackLink } from './SitePageLayout';
export type { SitePageLayoutProps, PageBackLinkProps } from './SitePageLayout';
export { SettingsPageLayout } from './SettingsPageLayout';
export { SiteShell, DiscoveryPageLayout } from './SiteShell';
export type { SiteShellProps, DiscoveryPageLayoutProps } from './SiteShell';
export {
  DiscoverySuspenseFallback,
  LegalSuspenseFallback,
  SettingsSuspenseFallback,
} from './SuspenseShellFallback';

/** Shared UX body patterns — class names every vertical theme should style consistently. */
export const SITE_PAGE_BODY = {
  feed: 'social-feed',
  feedCard: 'feed-card',
  feedCardEmpty: 'feed-card feed-card--empty',
  feedCardCompose: 'feed-card feed-card--compose',
  formCard: 'feed-card settings-page',
  error: 'form-error',
  muted: 'text-muted',
  btnPrimary: 'btn btn-primary',
  btnGhost: 'btn btn-ghost',
} as const;

export type SiteNavSection = {
  label: string;
  description: string;
  path: string;
};
